export default __webpack_public_path__ + "static/floating-78a69ad452a8908c4b17e493c35f22dc.png";